module.exports = __webpack_public_path__ + "ml.svg?64aa836720124c581eea7ae0d5b60443";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ml.svg
// module id = 1243
// module chunks = 0